import { useState } from 'react';
import { Flex, WhiteSection } from 'components/base/layout-components';
import WorkBreakdownChart from './WorkBreakdownChart';
import WorkBreakdownHeader from './WorkBreakdownHeader';
import {
  breakdownDataBuilder,
  emptyDataWorkBreakdown
} from './WorkBreakdownNew.service';
import WorkBreakdownTrendPopper from '../WorkBreakdown/WorkBreakdownTrendPopper';
import WidgetDescription from '../../../performance/views/CustomReport/Widgets/CustomWidget/Header/WidgetDescription';

const WorkBreakdownNew = ({
  teamWorkBreakdownData,
  workBreakdownTrendData
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { total } = teamWorkBreakdownData;
  const isEmptyData = total === '-' || total === 0;

  return (
    <WhiteSection
      borderRadius='0.45rem'
      height='22rem'
      width='25%'
      mb='0.75rem'
      ml='0.75rem'
      data-cy='work-breakdown-new'
    >
      <Flex direction='column' height='21.55rem' borderRadius='0.45rem'>
        <WorkBreakdownHeader anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
        <Flex height='4rem' direction='column' pt='0' pr='2rem' pl='2rem'>
          <WidgetDescription
            formattedAverage={total}
            formattedDescription='Code Changes'
          />
        </Flex>

        <WorkBreakdownChart
          workBreakdownData={
            isEmptyData
              ? emptyDataWorkBreakdown
              : breakdownDataBuilder(teamWorkBreakdownData)
          }
          isEmptyData={isEmptyData}
        />
        <WorkBreakdownTrendPopper
          anchorEl={anchorEl}
          data={workBreakdownTrendData}
          onClose={() => setAnchorEl(null)}
        />
      </Flex>
    </WhiteSection>
  );
};

export default WorkBreakdownNew;
